import Copytiger from "./Copytiger";

export default Copytiger;
